<template>
  <div class="login">
    <van-panel title="被访者信息" >
      <div>
        <van-form validate-first @failed="onFailed">
        <van-cell-group>
          <van-field v-model="vistor.fsIntervieweeName" required clearable label="被访者姓名"
              placeholder="请输入被访者姓名" name="asyncValidator"
              :rules="[{ validator: asyncValidator1, message: '请输入正确被访者姓名' }]"   />
          <van-field v-model="vistor.fsIntervieweePhone" required clearable label="被访者电话"
              placeholder="请输入被访者电话"
              :rules="[{ validator: asyncValidator2, message: '请输入正确被访者电话' }]"   />
<!--          <van-field name="radio" label="来访类型">
            <template #input>
              <van-radio-group v-model="vistor.fsVisitType" direction="horizontal">
                <van-radio name="1">单日来访</van-radio>
                <van-radio name="2">多日来访</van-radio>
              </van-radio-group>
            </template>
          </van-field> -->
          <van-field v-model="vistor.fsSdate" required readonly clearable label="访问时间"
              placeholder="点击选择日期" right-icon="arrow"  @click="showSd"/>
          <van-field v-model="vistor.fsEdate" required readonly clearable label="结束时间" v-if="vistor.fsVisitType=='2'"
              placeholder="点击选择日期" right-icon="arrow"  @click="showCalendar2 = true"/>
          <van-popup v-model="showCalendar" position="top">
            <van-datetime-picker  v-model="currTime" type="datehour" :formatter="formatter" @confirm="onConfirm" @cancel="showCalendar = false"/>
          </van-popup>
          <van-popup v-model="showCalendar2" position="top">
            <van-datetime-picker  v-model="currTime" type="datehour" :formatter="formatter" @confirm="onConfirm2" @cancel="showCalendar2 = false"/>
          </van-popup>
          </van-cell-group>
          </van-form>
      </div>
    </van-panel>
    <van-panel title="来访单位信息" >
        <div>
          <van-form validate-first @failed="onFailed">
            <van-cell-group>
              <van-field v-model="vistor.fsVisitorOrganization" required clearable label="来访单位"  placeholder="请输入来访单位"  />
            </van-cell-group>
            <van-cell-group>
            <van-field v-model="vistor.fsLpn" required clearable label="车牌号" placeholder="请输入车牌号,若未驾驶车辆请填无"  />
            </van-cell-group>
            <van-cell-group>
            <van-field v-model="vistor.fsVisitingReason" required clearable label="来访事由" placeholder="来访事由"  />
            </van-cell-group>
            </van-form>
        </div>
      </van-panel>
    <van-panel title="访客信息" >
      <div v-for="(item, index) in guestInfo" :key="index" style="position: relative;">
        <div class="dc_title">
          <span>访客{{index+1}}</span>
          <van-icon name="cross" color="red"  v-if="guestInfo.length > 1" @click="handleCross(index)"/>
        </div>
        <van-cell-group>
          <van-field v-model="item.fsVisitorName" required clearable label="访客姓名" placeholder="请输入访客姓名" />
          <van-field v-model="item.fsVisitorIdNum"   style="display: none;"  clearable label="身份证号" placeholder="请输入身份证号"  />
          <van-field v-model="item.fsVisitorPhone" required clearable label="访客电话" placeholder="请输入手机号"  />
          <van-field v-model="item.fnTemperature"  style="display: none;" clearable label="体温" placeholder="请输入体温"  />
          <van-field name="uploader" label="健康码"  style="display: none;">
            <template #input>
              <van-grid :column-num="1" :border="false">
                <van-grid-item>
                  <van-uploader :name="index" v-model="item.fsQrCode" @oversize="onOversize"  :max-size="5 * 1024 * 1024"  :before-read="beforeRead"
                  :after-read="afterRead" />
                </van-grid-item>
              </van-grid>
            </template>
          </van-field>
          <van-field v-model="item.fsRemark" clearable label="备注" placeholder="选填"  />
          <div class="vplus"  @click="handleAddVistor(index)">
            <van-icon name="plus"></van-icon>添加访客
          </div>
        </van-cell-group>
      </div>
    </van-panel>
    <div id="di_bottom"></div>
    <footer id="fi_bottom" v-if="showbtn">
        <div class="dc_btn dc_split" @click="handleReset()">重置</div>
        <div class="dc_btn" @click="handleSubmit()" >提交</div>
    </footer>
    <router-view></router-view>

    <van-dialog v-model="show" title="选择到访日期" width="100%" show-cancel-button>
      <datePiker  />
    </van-dialog>

    <van-dialog v-model="tip_show" title="入厂人员安全告知" :show-cancel-button=false :showConfirmButton="false">
      <div class="dc_aticle">
        <p style="text-indent:30px;">各位领导、客户及来访者，欢迎光临我司检查、参观、联系业务。为保证大家的人身健康与安全，请配合公司熟悉并遵守如下规定：</p>
        <p>1、进入公司前请在公司值班室配合保安人员进行必要登记及出示相关证件。进入厂区、库区的所有车辆请按照限速标志行驶，并按照指定地点停放。严禁酒后进入公司。</p>
        <p>2、请在指定地点（办公室或休息室吸烟点）吸烟，烟头要丢在烟灰缸内，厂区内禁止流动吸烟。</p>
        <p>3、严禁携带易燃、易爆和其他危险化学品进入公司厂区、库区，进入库区人员请在库区入口处交出火种。</p>
        <p>4、如需将公司物资带出厂，请主动出示《物资放行申请单》。</p>
        <p>5、严禁私自进入生产区域，如需进入生产现场，请在公司陪同人员引导下沿指定的安全路线行走；进入生产现场，应遵守各种安全警示标志的提示，佩戴必要的劳动防护用品，做好个人防护。</p>
        <p>6、公司配有医务室，如有身体不适，可立即联系身边的陪同人员。参观期间，如有火灾、地震等突发情况，您可就近拿取附件的救援物资使用。撤离时，请您听从陪同人员的引导，按照疏散指示有序撤离。</p>

        <p style="text-indent:30px;">请您认真阅读安全告知，衷心感谢您的配合！</p>
        <p style="text-align: center;">
          <van-button type="primary" size="small" @click="handleTip()">我已知晓</van-button>
        </p>
      </div>
    </van-dialog>

   </div>
</template>

<script>
import Exif from 'exif-js'
import { Dialog, Toast, Notify } from 'vant'
import Moment from 'moment'
import { getStaffInfo, addVistors,getCheckCode } from '../../services/guest.js'
import { isMobile,validateScale } from '../../utils/validate.js'

export default {
  name: 'guest',
  components: {
  },
  props: ['id'],
  data () {
    return {
      url: 'http://localhost:8080/#/guestadd/333',
      uploader: [],
      imgs: [],
      cur_index: 0,
      cur_img_index: 0,
      show: false,
      showCalendar: false,
      showCalendar2: false,
      showbtn: false,
      currTime: new Date(),
      check: 1,
      checkCode:'',
      tip_show: true,
      guestInfo: [{
        idkey: '',
        relIdkey: '',
        fsVisitorName: '',
        fsVisitorIdNum: '',
        fsVisitorPhone: '',
        fsVisitorOrganization: '',
        fsVisitingReason: '',
        fsVisitorImgUrl: [],
        fdCreateDate: '',
        fnSortOrder: 0,
        fnTemperature:'37',
        fsRemark: '',
        fsQrCode: [],
        fsTravelCode: [],
        fsReport: []
      },
      ],
      guest: {
        idkey: '',
        relIdkey: '',
        fsVisitorName: '',
        fsVisitorIdNum: '',
        fsVisitorPhone: '',
        fsVisitorOrganization: '',
        fsVisitingReason: '',
        fsVisitorImgUrl: [],
        fdCreateDate: '',
        fnSortOrder: 0,
        fnTemperature:'37',
        fsRemark: '',
        fsQrCode: [],
        fsTravelCode: [],
        fsReport: []
      },
      vistor: {
        idkey: '',
        fsIntervieweeId: '0',
        fsIntervieweeName: '',
        fsIntervieweePhone: '',
        fsLocatedId: '',
        fsVisitType: '2',
        fsSdate: '',
        fsEdate: '',
        fdCreateDate: '',
        fsSmsSeqNum: '',
        fsInvoiceState: '',
        fsInvoiceNum: '',
        fsVisitorOrganization: '',
        fsVisitingReason: '',
        fsLpn: '',
      },
      vistor_init: {
        idkey: '',
        fsIntervieweeId: '0',
        fsIntervieweeName: '',
        fsIntervieweePhone: '',
        fsLocatedId: '',
        fsVisitType: '2',
        fsSdate: '',
        fsEdate: '',
        fdCreateDate: '',
        fsSmsSeqNum: '',
        fsInvoiceState: '',
        fsInvoiceNum: '',
        fsVisitorOrganization: '',
        fsVisitingReason: '',
        fsLpn: '',
      },
      user: {},
      guestInfo_init: [{
        idkey: '',
        relIdkey: '',
        fsVisitorName: '',
        fsVisitorIdNum: '',
        fsVisitorPhone: '',
        fsVisitorOrganization: '',
        fsVisitingReason: '',
        fsVisitorImgUrl: [],
        fdCreateDate: '',
        fnSortOrder: 0,
        fnTemperature:'37',
        fsRemark: '',
        fsQrCode: [],
        fsTravelCode: [],
        fsReport: []
      },
      ],
    }
  },
  mounted: function () {
    this.getCheckCode();
  },
  methods: {
    handleTip() {
      this.tip_show = false;
      this.showbtn = true;
    },
    onOversize (file) {
      console.log(file);
      Toast('文件大小不能超过 5m');
    },
    showSd () {
      this.showCalendar = true
      this.currTime = new Date()
    },
    showEd () {
      this.showCalendar2 = true
      this.currTime = new Date()
    },
    formatter (type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      } else if (type === 'hour') {
        return `${value}时`
      } else if (type === 'minute') {
        return `00分`
      } else if (type === 'second') {
        return `${value}秒`
      }
      return value
    },
    handleSubmit () {
      if (this.vistor.fsIntervieweeId === '0' || this.user.fsIntervieweePhone === 'err') {
        Notify({ type: 'danger', message: '请输入正确的被访人和电话' });
        return false;
      }
      if (this.vistor.fsSdate === '') {
        Notify({ type: 'danger', message: '请选择访问时间' });
        return false;
      }
      if (this.vistor.fsEdate === '' && this.vistor.fsVisitType === '2') {
        Notify({ type: 'danger', message: '请选择结束时间' });
        return false;
      }
      if (this.vistor.fsVisitorOrganization === '') {
        Notify({ type: 'danger', message: '请填写来访单位' });
        return false;
      }
      if (this.vistor.fsVisitingReason === '') {
        Notify({ type: 'danger', message: '请填写来访事由' });
        return false;
      }
      if (this.vistor.fsLpn === '') {
        Notify({ type: 'danger', message: '请填写车牌号，未驾车填写无' });
        return false;
      }

      for (let i = this.guestInfo.length - 1; i >= 0; i--) {
        let obj = this.guestInfo[i];
        let index = i + 1;
        if (obj.fsVisitorName === '' && obj.fsVisitorPhone === ''  && this.guestInfo.length > 1) {
          this.guestInfo.splice(i, 1);
          continue;
        }
        if (obj.fsVisitorName === '' || obj.fsVisitorPhone === ''  
          ) {
          Notify({ type: 'danger', message: '访客' + (index) + '的信息填写不完整' });
          this.check = 0;
          break;
        }
        if (obj.fsVisitorPhone !== '' && !isMobile(obj.fsVisitorPhone)) {
          Notify({ type: 'danger', message: '访客' + (index) + '的手机号填写错误' });
          this.check = 0;
          break;
        }
        if (obj.fnTemperature !== '' && !validateScale(obj.fnTemperature)) {
          Notify({ type: 'danger', message: '访客' + (index) + '的体温填写错误，需填写正确的数字' });
          this.check = 0;
          break;
        }

        this.check = 1;
        obj.fnSortOrder = index;
      }
      //console.log(this.guestInfo)
      //return;
      if (this.check === 1) {
        if (this.guestInfo.length === 0) {
          Notify({ type: 'danger', message: '请填写访客信息' });
        }
        Toast.loading({
          duration: 0,
          message: '提交中...',
          forbidClick: true,
        });
        addVistors({ 'vistor': this.vistor, 'guest': this.guestInfo ,"checkcode":this.checkCode}).then(res => {
          let info = res.data;
          if (info.code === 200) {
            // Notify({ type: 'success', message: info.msg });
            Dialog.alert({ message: info.msg, }).then(() => {});
            Toast.clear(true);
            if(info.msg.indexOf("提交成功")==-1){
              this.getCheckCode();
            }
            this.showbtn = false;
          }
        })
      }
    },
    getCheckCode(){
      getCheckCode().then(res => {
        this.checkCode = res.data.msg;
      })
    },
    onRead (file, index) {
    },
    onFailed (errorInfo) {
      console.log('failed', errorInfo);
    },
    afterRead(file, detail) {
      // console.log(this.guestInfo.fsQrCode)
      this.cur_index = detail.name;
      this.cur_img_index = detail.index;
      this.imgPreview(file.file, 'fsQrCode')
      // console.log(this.guestInfo)
    },
    afterRead2(file, detail) {
      this.cur_index = detail.name;
      this.cur_img_index = detail.index;
      this.imgPreview(file.file, 'fsTravelCode')
    },
    afterRead3(file, detail) {
      this.cur_index = detail.name;
      this.cur_img_index = detail.index;
      this.imgPreview(file.file, 'fsReport')
    },
    beforeRead (file) {
      if (file.type.indexOf('image') === -1) {
        Notify({ type: 'danger', message: '请上传图片' });
        return false;
      }
      return true;
    },
    validUser (col, resolve) {
      if (this.vistor.fsIntervieweeName !== '' || this.vistor.fsIntervieweePhone !== '') {
		if( this.vistor.fsIntervieweePhone.indexOf(" ")>-1){
			this.vistor.fsIntervieweePhone = this.vistor.fsIntervieweePhone.split(" ").join("");
		}
        getStaffInfo(this.vistor).then(res => {
          this.user = res.data.data
          console.log(this.user)
          Toast.clear()
          if (col === 'fsIntervieweeName' && res.data.data.fsIntervieweeName === 'err') {
            resolve(false);
          } else if (col === 'fsIntervieweePhone' && (res.data.data.fsIntervieweePhone == null || res.data.data.fsIntervieweePhone === 'err')) {
            resolve(false);
          } else {
            this.vistor.fsIntervieweeId = this.user.idkey
            this.vistor.fsIntervieweeName = this.user.fsIntervieweeName

            return true;
          }
        })
      }
    },
    asyncValidator1 (val) {
      if (this.vistor.fsIntervieweeName === '' || this.vistor.fsIntervieweePhone === '') {

      } else {
        return new Promise((resolve) => {
          Toast.loading('验证中...');
          this.validUser('fsIntervieweeName', resolve);
        });
      }
    },
    asyncValidator2 (val) {
      if (this.vistor.fsIntervieweeName === '' || this.vistor.fsIntervieweePhone === '') {

      } else {
        return new Promise((resolve) => {
          Toast.loading('验证中...');
          this.validUser('fsIntervieweePhone', resolve);
        });
      }
    },
    handleCross (index) {
      this.guestInfo.splice(index, 1);
    },
    handleAddVistor (index) {
      let { ...add } = this.guest;
      this.guestInfo.push(add);
    },
    handleDatePicker () {
      this.show = true
      // this.$router.push('/datepicker')
    },
    handleReset () {
      Object.assign(this.$data, this.$options.data.call(this));
      // this.vistor = Object.assign({}, this.vistor_init);
      // this.guestInfo = Object.assign({}, this.guestInfo_init);
    },
    onConfirm (date) {
      let today = Moment().format('YYYY-MM-DD HH:00');
      // this.vistor.fsSdate = Moment(date).format('YYYY-MM-DD HH:mm'); ;// `${date.getMonth() + 1}/${date.getDate()}`;
      let dt = Moment(date).format('YYYY-MM-DD HH:00');
      if (dt < today) {
        Notify({ type: 'danger', message: '开始时间不能小于当天' });
        return false;
      }
      if (this.vistor.fsEdate !== '' && dt > this.vistor.fsEdate) {
        Notify({ type: 'danger', message: '结束时间不能小于访问时间' });
        return false;
      }
      let days = Moment(Moment(date).format('YYYY-MM-DD')).diff(Moment().format('YYYY-MM-DD'), 'day');
      if (days > 2) {
        Notify({ type: 'danger', message: '只能预约3日内的来访（含当天）' });
        return false;
      }
      this.vistor.fsSdate = dt;
      this.showCalendar = false;
    },
    onConfirm2 (date) {
      let dt = Moment(date).format('YYYY-MM-DD HH:00');
      if (dt < this.vistor.fsSdate) {
        Notify({ type: 'danger', message: '结束时间不能小于访问时间' });
        return false;
      }
      let days = Moment(Moment(date).format('YYYY-MM-DD')).diff(Moment().format('YYYY-MM-DD'), 'day');
      if (days > 2) {
        Notify({ type: 'danger', message: '只能预约3日内的来访（含当天）' });
        return false;
      }
      this.vistor.fsEdate = dt;
      this.showCalendar2 = false;
    },
    //
    // 处理图片
    imgPreview(file, code) {
      let self = this
      let Orientation
      // 去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save   这里需要安装一下包
      Exif.getData(file, function() {
        Orientation = Exif.getTag(this, 'Orientation')
      })
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader()
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file)
        // 读取成功后的回调
        reader.onloadend = function() {
          let result = this.result
          let img = new Image()
          img.src = result
          // 判断图片是否大于500K,是就直接上传，反之压缩图片
          if (this.result.length <= 500 * 1024) {
            // 上传图片
            // self.imgs.push({ 'content': this.result });
            // self.guestInfo[self.cur_index].fsQrCode.splice(self.cur_img_index, 1, { 'content': this.result })
            self.guestInfo[self.cur_index][code].splice(self.cur_img_index, 1, { 'content': this.result })
          } else {
            img.onload = function() {
              let data = self.compress(img, Orientation)
              // 上传图片
              // self.imgs.push({ 'content': data });
              // self.guestInfo.fsQrCode.splice(self.cur_index, 1, { 'content': data })
              // self.guestInfo[self.cur_index].fsQrCode.splice(self.cur_img_index, 1, { 'content': data })
              self.guestInfo[self.cur_index][code].splice(self.cur_img_index, 1, { 'content': data })
            }
          }
        }
      }
    },
    // 压缩图片
    compress(img, Orientation) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      // 瓦片canvas
      let tCanvas = document.createElement('canvas')
      let tctx = tCanvas.getContext('2d')
      // let initSize = img.src.length;
      let width = img.width
      let height = img.height
      // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio
      if ((ratio = (width * height) / 4000000) > 1) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio)
        width /= ratio
        height /= ratio
      } else {
        ratio = 1
      }
      canvas.width = width
      canvas.height = height
      //    铺底色
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      // 如果图片像素大于100万则使用瓦片绘制
      let count
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1) // 计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count)
        let nh = ~~(height / count)
        tCanvas.width = nw
        tCanvas.height = nh
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height)
      }
      // 修复ios上传图片的时候 被旋转的问题
      if (Orientation !== '' && Orientation !== 1) {
        switch (Orientation) {
          case 6: // 需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas)
            break
          case 8: // 需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas)
            break
          case 3: // 需要180度旋转
            this.rotateImg(img, 'right', canvas) // 转两次
            this.rotateImg(img, 'right', canvas)
            break
        }
      }
      // 进行最小压缩
      let ndata = canvas.toDataURL('image/jpeg', 0.1)
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      // console.log(ndata)
      return ndata
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      // 最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0
      const max_step = 3
      if (img == null) return
      // img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height
      let width = img.width
      let step = 2
      if (step == null) {
        step = min_step
      }
      if (direction === 'right') {
        step++
        // 旋转到原位置，即超过最大值
        step > max_step && (step = min_step)
      } else {
        step--
        step < min_step && (step = max_step)
      }
      // 旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180
      let ctx = canvas.getContext('2d')
      switch (step) {
        case 0:
          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0)
          break
        case 1:
          canvas.width = height
          canvas.height = width
          ctx.rotate(degree)
          ctx.drawImage(img, 0, -height)
          break
        case 2:
          canvas.width = width
          canvas.height = height
          ctx.rotate(degree)
          ctx.drawImage(img, -width, -height)
          break
        case 3:
          canvas.width = height
          canvas.height = width
          ctx.rotate(degree)
          ctx.drawImage(img, -width, 0)
          break
      }
    },
    // 将base64转换为文件
    dataURLtoFile(dataurl) {
      var arr = dataurl.split(',');
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type
      })
    },
    //
    login () {
      if (this.username && this.password) {
        this.$router.push('/tabs')
      } else {
        Dialog.alert({
          message: '请输入用户名密码！',
        }).then(() => {
          // on close
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
    .van-panel__header{
      background-color: #F0F2F2;
      text-align: left;
      .van-cell__title{
        font-size: 0.27333rem;
      }
      .van-cell{
        padding:0.16667rem 0.42667rem;
      }
    }
    .vplus{
      font-size: 14px;
      color: #06CBD8;
      padding: 10px;;
    }
    .dc_title{
      color: #FF8B13;
      font-size: 0.26333rem;
      padding: 10px 30px;
      text-align: left;
      position: relative;
    }
    .van-icon-cross{
      float: right;
      font-size: 0.36333rem;
    }
    #di_bottom{
      background-color: gray;
      left: 0px;
      width: 100%;
      height: 90px;
      z-index: 9999;
    }
    #fi_bottom{
      position: fixed;
      left: 0px;
      bottom: 0px;
      width: 100%;
      height: 40px;
      background-color: #06CBD8;
      z-index: 9999;
      .dc_btn{
        float: left;
        width: 49.5%;
        line-height: 40px;
        font-size: 0.46333rem;
        color: white;
      }
      .dc_split{
        border-right: 1px solid white;
      }
    }
    .van-dialog{
      border-radius:0;
    }
    .van-tabs__nav--card .van-tab {
        color: #06CBD8;
        border-right: 0.02667rem solid #06CBD8;
    }
    .van-tab__text, .van-tab__text--ellipsis{
      color: #06CBD8;
    }
    .van-popup--bottom{
      bottom: 90px;
    }
    .lc_tips{
      font-size: 11px;
      color: red;
    }
    #app .van-grid-item__content{
      padding: 0!important;
    }
    .dc_aticle{
      text-align: left;
      height: 360px;
      overflow: auto;
      padding: 0px 15px;
    }
    .dc_aticle p{
      text-align: left;
    }
</style>
